
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import wx from 'weixin-js-sdk';
	import AbpBase from '@/lib/abpbase';
	@Component({
		components: {

		}
	})

	export default class CommentAudit extends AbpBase {
		pageSize: number = 10;
		pageIndex: number = 1;
		commentList: Array < Object >= new Array < Object > ();
		loadmore: boolean = true;
		status: number = 0;

		changeStatus(status) {
			var that = this;
			that.pageIndex = 1;
			that.commentList = [];
			that.status = status;
			that.loadmore = true;
			that.getNewsCommentList();
		}
		commentAudit(commentid) {
			var that = this;
			this.$Modal.confirm({
				title: this.L('Tips'),
				content: this.L('确定要审核通过吗'),
				okText: this.L('Yes'),
				cancelText: this.L('No'),
				onOk: async () => {
					await this.$store.dispatch({
						type: 'app/updateCommentApproved',
						id: commentid
					})
					that.pageIndex = 1;
					that.commentList = [];
					that.loadmore = true;
					that.getNewsCommentList();

				}
			})
		}
		commentDelete(commentid) {
			var that = this;
			this.$Modal.confirm({
				title: this.L('Tips'),
				content: this.L('DeleteConfirm'),
				okText: this.L('Yes'),
				cancelText: this.L('No'),
				onOk: async () => {
					await this.$store.dispatch({
						type: 'app/commentDelete',
						id: commentid
					})
					that.pageIndex = 1;
					that.commentList = [];
					that.loadmore = true;
					that.getNewsCommentList();
				}
			})
		}
		handleReachBottom() {
			var that = this;
			if (that.loadmore) {
				that.pageIndex++;
				that.getNewsCommentList();
			}
		}
		getNewsCommentList() {
			var that = this;
			var request = new Object() as any;
			request.maxResultCount = this.pageSize;
			request.skipCount = (this.pageIndex - 1) * this.pageSize;
			request.status = that.status;
			if (that.status) {
				request.selectAll = false;
			} else {
				request.selectAll = true;
			}
			request.sort = 1;
			this.$store.dispatch({
				type: 'app/getNewsCommentList',
				data: request
			}).then((res) => {
				var result = res.items as Array < Object > ;
				if (result.length < that.pageSize) {
					that.loadmore = false;
				}
				for (var i = 0; i < result.length; i++) {
					(result[i] as any).datetime = Util.formatDateStr((result[i] as any).creationTime);
					that.commentList.push(result[i]);
				}
				console.log(that.commentList);
				//that.commentList = res as Array < Object > ;
				//(that.news as any).time = Util.formatDate(new Date((that.news as any).creationTime), 'yyyy-MM-dd hh:mm:ss');
			})
		}

		async created() {
			if (!Util.abp.session.userId) {
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}
			if (Util.abp.session.userId) {
				this.getNewsCommentList();
			}
		}
		mounted() {
			window.addEventListener("scroll", this.onScroll);
		}
		onScroll() {
			var that = this;
			//可滚动容器的高度
			let innerHeight = (this.$refs.scroll as any).clientHeight;
			//屏幕尺寸高度
			let outerHeight = document.documentElement.clientHeight;
			//可滚动容器超出当前窗口显示范围的高度
			let scrollTop = document.documentElement.scrollTop;
			//scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
			console.log(innerHeight + " " + outerHeight + " " + scrollTop);
			if (innerHeight <= outerHeight + scrollTop) {
				//加载更多操作

				that.handleReachBottom();
			}
		}
	}
